<script>
import ProductTotalTaxaVue from './ProductTotalTaxa.vue';

export default {
  name: 'ProductDebitCardValueTaxaColumn',
  extends: ProductTotalTaxaVue,
  computed: {
    columnValueType() {
      return 'cartaoDebito';
    },
  },
};
</script>
